import { useMedia } from '~/hooks/useMedia'
import clsx from 'clsx'

type Props = {
  className?: string
  withoutTemplate?: boolean
}

export const LoadingColumns = ({ withoutTemplate, className }: Props) => {
  const isDesktop = useMedia('lg')
  const loop = isDesktop ? [0, 1, 2, 3, 4, 5, 6, 7, 8, 9] : [0, 1, 2, 3]

  const LoadingCard = () => (
    <figure className="relative h-full w-full animate-pulse">
      {/* Product Image Container */}
      <div className="relative aspect-[4/5] w-full">
        <div className="absolute inset-0 overflow-hidden rounded-[5px] bg-sg-light-grey" />
      </div>

      {/* Content Section */}
      <div className="w-full pb-[15px] pt-2.5">
        <figcaption className="relative flex flex-col items-start gap-2.5">
          {/* Color Thumbs Placeholder */}
          <div className="min-h-[28px] w-full lg:min-h-[40px]">
            <div className="flex gap-[5px] lg:gap-2.5">
              {[1, 2, 3].map((i) => (
                <div
                  key={i}
                  className="h-[26px] w-[26px] rounded-[5px] bg-sg-light-grey lg:h-[40px] lg:w-[40px]"
                />
              ))}
            </div>
          </div>

          {/* Badges Placeholder */}
          <div className="flex gap-1.5">
            <div className="h-6 w-16 rounded bg-sg-light-grey" />
          </div>

          {/* Product Name Placeholder */}
          <div className="w-full space-y-2">
            <div className="h-[18px] w-3/4 rounded bg-sg-light-grey lg:h-[22px]" />
            <div className="h-[18px] w-1/2 rounded bg-sg-light-grey lg:h-[22px]" />
          </div>

          {/* Features Section Placeholder */}
          <div className="flex gap-2.5">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="h-[14px] w-[14px] rounded-full bg-sg-light-grey lg:h-[22px] lg:w-[22px]"
              />
            ))}
          </div>

          {/* Price Placeholder */}
          <div className="h-[22px] w-24 rounded bg-sg-light-grey" />

          {/* Rating Stars Placeholder */}
          <div className="flex gap-1">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="h-4 w-4 rounded-full bg-sg-light-grey" />
            ))}
          </div>
        </figcaption>
      </div>
    </figure>
  )

  const cards = loop.map((i) => (
    <li key={i} className="min-h-[400px] lg:min-h-[520px]">
      <LoadingCard />
    </li>
  ))

  return withoutTemplate ? (
    <>{cards}</>
  ) : (
    <ul
      className={clsx(
        'grid w-full grid-cols-2 gap-x-2.5 gap-y-2.5 px-5 lg:grid-cols-6 lg:gap-x-5 lg:gap-y-[65px] lg:px-[50px]',
        className,
      )}
    >
      {cards}
    </ul>
  )
}
